import script from "./SettingSidebarMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingSidebarMobile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__